import { HistoryRecord } from 'libs/types/history/historyTypes';
import { v4 as uuid } from 'uuid';

export function revertHistoryOperation(record: HistoryRecord) {
    if (record.operation === 'add') {
        return {
            recordId: uuid(),
            operation: 'delete',
            data: record.data
        };
    }
    if (record.operation === 'delete') {
        return {
            recordId: uuid(),
            operation: 'add',
            data: record.data
        };
    }
    if (record.operation === 'update') {
        return {
            recordId: uuid(),
            operation: 'update',
            data: record.previousData,
            previousData: record.data,
            props: record.props
        };
    }
    if (record.operation === 'reorder') {
        return {
            recordId: uuid(),
            operation: 'reorder',
            data: record.previousData,
            previousData: record.data
        };
    }
    if (record.operation === 'updateMap') {
        return {
            recordId: uuid(),
            operation: 'updateMap',
            data: record.previousData,
            previousData: record.data
        };
    }
}
